import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import SvgArsEmptyReport from '@/pages/reports/ats-reports/components/empty-report/Icon';

export const EmptyReport = () => {
  return (
    <Box flex="1" height="100%">
      <Flex
        alignItems="center"
        justifyContent="center"
        height="100%"
        flexDir="column"
      >
        <Icon as={SvgArsEmptyReport} w="fit-content" h="fit-content" />
        <Text fontWeight="semiBold" fontSize="20px" mt="12px">
          Nothing found
        </Text>
        <Text
          fontWeight={400}
          fontSize="14px"
          w="420px"
          textAlign="center"
          mt="12px"
        >
          Sorry but it looks like there’s no data available for the time or
          filter you indicated. Please try readjusting.
        </Text>
      </Flex>
    </Box>
  );
};
